// removed by extract-text-webpack-plugin
module.exports = {"content":"_1vNFn9dPWSDNUHTzOTpWqP"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/organisms/Timeline/Containers/BoxText/style.css
// module id = 633
// module chunks = 38